/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthTokenDto } from '../models/AuthTokenDto';
import type { CreateAuthTokenRequest } from '../models/CreateAuthTokenRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
  /**
   * @param requestBody
   * @returns AuthTokenDto OK
   * @throws ApiError
   */
  public static createAuthToken(
    requestBody?: CreateAuthTokenRequest,
  ): CancelablePromise<AuthTokenDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/auth/token',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
